var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtualSources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.17,55.43h-9.97c-6.19,0-11.21-5.02-11.21-11.21s5.02-11.21,11.21-11.21c.96,0,1.89.12,2.77.35h0c.91-4.45,3.54-8.28,7.16-10.77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.48,42.93c.95,1.26,1.52,2.76,1.52,4.37,0,4.49-3.64,8.13-8.13,8.13h-4.28"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 41.94,
    cy: 21.61,
    rx: 5.44,
    ry: 5.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 41.94,
    cy: 53.39,
    rx: 5.44,
    ry: 5.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 59.03,
    cy: 30.53,
    rx: 5.44,
    ry: 5.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.94,
    y1: 26.94,
    x2: 41.94,
    y2: 48.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.94,43.94l13.48-2.36c2.09-.37,3.62-2.18,3.62-4.31v-1.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualSources);
export default __webpack_public_path__ + "static/media/__Virtual Sources.cfc1b92a2fd4fae5cdd7aec08bedb571.svg";
export { ForwardRef as ReactComponent };